/**
 * Event Bus Vuex Store
 * Manages event listeners and provides async event emission
 */

const state = {
  events: {} // { eventName: [callback1, callback2, ...] }
}

const mutations = {
  register(state, { event, callback }) {
    if (!state.events[event]) {
      state.events[event] = []
    }
    
    // Avoid duplicate registrations
    if (!state.events[event].includes(callback)) {
      state.events[event].push(callback)
    }
  },

  unregister(state, { event, callback }) {
    if (state.events[event]) {
      const index = state.events[event].indexOf(callback)
      if (index > -1) {
        state.events[event].splice(index, 1)
      }
      
      // Clean up empty event arrays
      if (state.events[event].length === 0) {
        delete state.events[event]
      }
    }
  }
}

const actions = {
  async emitEvent({ getters }, { event, payload }) {
    const listeners = getters.listeners(event)
    
    if (listeners && listeners.length > 0) {
      // Execute all listeners asynchronously
      const promises = listeners.map(callback => {
        try {
          const result = callback(payload)
          // Handle both sync and async callbacks
          return Promise.resolve(result)
        } catch (error) {
          console.error(`Error in event listener for ${event}:`, error)
          return Promise.resolve()
        }
      })
      
      await Promise.all(promises)
    }
  },

  registerEvent({ commit }, { event, callback }) {
    commit('register', { event, callback })
  },

  unregisterEvent({ commit }, { event, callback }) {
    commit('unregister', { event, callback })
  }
}

const getters = {
  listeners: (state) => (event) => {
    return state.events[event] || []
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}